import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const vaccineTypeLocaleModule: LocaleModule = {
  name: "vaccineType",
  messages: { en: en, it: it },
};
